var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 141,
    viewBox: "0 0 200 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.485 106.289C60.2549 107.519 60.2549 109.514 61.485 110.744C62.7152 111.974 64.7096 111.974 65.9398 110.744L99.9995 76.6844L134.06 110.745C135.29 111.975 137.284 111.975 138.515 110.745C139.745 109.514 139.745 107.52 138.515 106.29L104.454 72.2296L141.437 35.2465C142.667 34.0164 142.667 32.0219 141.437 30.7918C140.207 29.5616 138.213 29.5616 136.983 30.7918L99.9995 67.7748L63.017 30.7923C61.7869 29.5622 59.7924 29.5622 58.5623 30.7923C57.3321 32.0225 57.3321 34.017 58.5623 35.2471L95.5447 72.2296L61.485 106.289Z",
    fill: "#00ABC5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c6dc06cf306a335f8fa68414128769ce.svg";
export { ForwardRef as ReactComponent };